import { useQuery } from '@tanstack/react-query';
import { POLL_MS } from '../config';
import { getSourceConnectors } from '../endpoints';
import { queryKeys } from '../queryKeys';
import { queryRetry } from './shared';

export interface UseSourceConnectorsOptions {
  readonly enabled?: boolean;
  readonly pollMs?: number | false;
}

// Connector state, polled every 2.5 s while the caller keeps it enabled
// (api-surface section 4). Pass pollMs: false for one-shot reads.
export function useSourceConnectors(options: UseSourceConnectorsOptions = {}) {
  return useQuery({
    queryKey: queryKeys.sourceConnectors(),
    queryFn: ({ signal }) => getSourceConnectors(signal),
    enabled: options.enabled ?? true,
    refetchInterval: options.pollMs === undefined ? POLL_MS.sourceConnectors : options.pollMs,
    refetchIntervalInBackground: false,
    retry: queryRetry,
  });
}
